import { useEffect, useState } from 'react';
import { DisplayData, OpType, ProductOpValue, TextOPValue } from '../types';
import { Text } from './TextPlugin';
import { usePersistCallback } from '../../../../hooks/usePersistCallback';
import { Product } from './ProductPlugin';

export type ImageType = 'base64' | 'url';

export const useCatalogData = (
  values?: DisplayData,
  imageType: ImageType = 'base64'
) => {
  const [data, setData] = useState<React.ReactElement[]>();

  const process = usePersistCallback(() => {
    const res: React.ReactElement[] =
      values?.map((item) => {
        switch (item.type) {
          // 文本
          case OpType.TEXT:
            const textConfig = item.value as TextOPValue;
            return <Text value={textConfig} />;
          // 产品
          case OpType.PRODUCT:
            const productConfig = item.value as ProductOpValue;
            return <Product value={productConfig} imageType={imageType} />;
          default:
            // 如果没有命中，直接返回空
            return <></>;
        }
      }) ?? [];
    setData(res);
  });

  useEffect(() => {
    process();
  }, [process, values]);

  return data;
};
